import { useState, useEffect } from "react";
import axios from "axios";
import HeroSection from "@/components/csr/HeroSection";
import TrustStrip from "@/components/csr/TrustStrip";
import ImpactSnapshot from "@/components/csr/ImpactSnapshot";
import CSROverview from "@/components/csr/CSROverview";
import DigitalInfrastructure from "@/components/csr/DigitalInfrastructure";
import FeaturedStates from "@/components/csr/FeaturedStates";
import PartnershipFormats from "@/components/csr/PartnershipFormats";
import ComplianceCard from "@/components/csr/ComplianceCard";
import PartnerSignals from "@/components/csr/PartnerSignals";
import FAQSection from "@/components/csr/FAQSection";
import PartnershipProcess from "@/components/csr/PartnershipProcess";
import FinalCTA from "@/components/csr/FinalCTA";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/csr/StickyCTA";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LandingPage = () => {
  const [loading, setLoading] = useState(true);
  const [inquiryContext, setInquiryContext] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log("API Status:", response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handler to open inquiry form with context
  const handleOpenInquiry = (context) => {
    setInquiryContext(context);
    // Scroll to top where the form is
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Clear inquiry context after it's used
  const clearInquiryContext = () => {
    setInquiryContext(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9F7]" data-testid="loading-screen">
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-[#6B7280]">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F9F7]" data-testid="landing-page">
      {/* Sticky CTA Header */}
      <StickyCTA />

      {/* CSR Cycle Note - Slim Strip with Blinking FY */}
      <div className="bg-[#FFF8E6] border-b border-[#F4C430]/30 py-2.5 px-4">
        <div className="container mx-auto text-center">
          <p className="text-sm text-[#4A4A4A]">
            <span className="font-semibold text-[#2F2F2F]">CSR Cycle Note – </span>
            <span className="font-bold text-[#B8860B] animate-pulse">FY 2025–26</span>
            <span className="font-semibold text-[#2F2F2F]">:</span>{" "}
            Organisations reviewing current-year CSR allocations or unspent balances may explore structured state-level participation models.
          </p>
        </div>
      </div>
      
      {/* BLOCK 1: Hero + Leadership + Journey */}
      <HeroSection inquiryContext={inquiryContext} onClearContext={clearInquiryContext} />
      
      {/* BLOCK 2: Impact Snapshot (KPIs moved up) */}
      <ImpactSnapshot />
      
      {/* BLOCK 3: CSR Partnership Overview (What + Who) */}
      <CSROverview />
      
      {/* BLOCK 4: DHRUVA + Government Recognition (moved up - institutional backbone) */}
      <DigitalInfrastructure />
      
      {/* BLOCK 5: Featured State Implementations */}
      <FeaturedStates onOpenInquiry={handleOpenInquiry} />
      
      {/* BLOCK 6: Partnership Formats / Engagement Models */}
      <PartnershipFormats />
      
      {/* BLOCK 7: Compliance/Governance (Institution-Ready) */}
      <ComplianceCard />
      
      {/* BLOCK 8: Partner Signals / Testimonials */}
      <PartnerSignals />
      
      {/* BLOCK 9: FAQs */}
      <FAQSection />
      
      {/* BLOCK 10: How the Partnership Process Works */}
      <PartnershipProcess />
      
      {/* BLOCK 11: Final CTA */}
      <FinalCTA />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
